import { Icon, Typography } from '@scale/scaleui';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { RubricAttributeSchema } from '@scale/shared/pipelinev3/genai';
import { RubricAttribute } from '@scale/shared/types/params/textcollection';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface RubricAttributesBuilderProps {
  name: string;
  hint?: string;
  existingValue?: Array<RubricAttribute>;
  updateProperty: (arg: Array<RubricAttribute> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const RubricAttributesBuilder: React.FC<RubricAttributesBuilderProps> = ({
  name,
  hint,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const attributes = existingValue || [];
  return (
    <div className="flex flex-col gap-2">
      <Typography.Subtitle3>{name}</Typography.Subtitle3>
      {hint && <Typography.Paragraph3>{hint}</Typography.Paragraph3>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={attributes}
        setElements={updateProperty}
        getKey={attribute => JSON.stringify(attribute)}
        getTitle={attribute => attribute.label || '<New Attribute>'}
        getSchema={_ => RubricAttributeSchema}
      />
      <Icon
        hasBackground
        icon={['fas', 'plus']}
        onClick={() =>
          updateProperty([
            ...attributes,
            {
              value: '',
              label: '',
              categories: [],
            },
          ])
        }
        size="md"
        variant="primary"
      />
    </div>
  );
};

export default RubricAttributesBuilder;
